export default "__VITE_PUBLIC_ASSET__71ad3e10__"